/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         30/04/24 - 09:54:30
 * Module name:  headers-groups-table.const
 * File name:    headers-groups-table.const.ts
 * IDE:          WebStorm
 */

import { NbPosition } from '@nebular/theme';
import {
  TableColumnAlignEnum,
  TableColumnEnum,
  TableColumnInterface,
  TableIconEnum,
} from '@shared/components/table/utils';
import { CustomerLevelEnum } from '@shared/interface/settings/customer/customers/customers.interface';

/**
 * @description
 * Header array for customer table child
 */
export const CUSTOMER_HEADERS: TableColumnInterface[] = [
  {
    field: 'level',
    type: TableColumnEnum.iconEnum,
    header: 'app.setting.customer.fields.level.label',
    grow: 0.5,
    align: TableColumnAlignEnum.center,
    enumIcon: {
      [CustomerLevelEnum.diamond]: TableIconEnum.gem,
      [CustomerLevelEnum.zafiro]: TableIconEnum.diamond4,
      [CustomerLevelEnum.platinum]: TableIconEnum.certificate,
      [CustomerLevelEnum.gold]: TableIconEnum.seal,
      [CustomerLevelEnum.silver]: TableIconEnum.circle,
      [CustomerLevelEnum.final]: TableIconEnum.user
    },
    enumIconTooltip: {
      [CustomerLevelEnum.diamond]: 'app.setting.customer.fields.level.list.diamond',
      [CustomerLevelEnum.zafiro]: 'app.setting.customer.fields.level.list.zafiro',
      [CustomerLevelEnum.platinum]: 'app.setting.customer.fields.level.list.platinum',
      [CustomerLevelEnum.gold]: 'app.setting.customer.fields.level.list.gold',
      [CustomerLevelEnum.silver]: 'app.setting.customer.fields.level.list.silver',
      [CustomerLevelEnum.final]: 'app.setting.customer.fields.level.list.final',
    },
    tooltipAlign: NbPosition.END,
  },
  {
    field: 'tax_id',
    type: TableColumnEnum.text,
    header: 'app.setting.customer.fields.nit.label',
    grow: 0.5,
    align: TableColumnAlignEnum.end,
  },
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.customer.fields.name.label',
    align: TableColumnAlignEnum.start,
    grow: 1.5,
    sort: true,
  },
  {
    field: 'initials',
    type: TableColumnEnum.text,
    header: 'app.setting.customer.fields.initials.label',
    grow: 0.5,
    align: TableColumnAlignEnum.center
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.customer.fields.status.header',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'logo',
    type: TableColumnEnum.image,
    header: 'app.setting.customer.fields.logo.label',
    grow: 0.5,
    align: TableColumnAlignEnum.center,
    dualIcon: [TableIconEnum.image, TableIconEnum.imageSlash],
  },
];
